
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 0a9 9 0 110 18A9 9 0 019 0zm.56 6.997c-.787 0-1.494.395-2.036.91-.178.176-.774.746-.774.99 0 .082.082.177.177.177.244 0 .895-1.18 1.397-1.18.11 0 .232.121.137.365l-.95 2.39c-.096.23-.557 1.343-.557 1.994 0 .516.34.747.828.747 1.371 0 2.958-1.683 2.958-2.077 0-.121-.095-.204-.163-.204-.19 0-.936 1.154-1.343 1.154-.109 0-.163-.095-.163-.19 0-.217.15-.557.23-.76l.978-2.646c.488-1.317-.136-1.67-.719-1.67zm.745-2.497c-.596 0-1.112.489-1.112 1.086 0 .556.367.923.923.923.611 0 1.126-.462 1.126-1.086 0-.557-.392-.923-.937-.923z","fill":"#008988","fill-rule":"evenodd"}})])
          )
        }
      }
    